/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TransferEdictRequest
 */
export interface TransferEdictRequest {
    /**
     * 
     * @type {string}
     * @memberof TransferEdictRequest
     */
    sourceReference: string;
    /**
     * 
     * @type {string}
     * @memberof TransferEdictRequest
     */
    clientId: string;
}

/**
 * Check if a given object implements the TransferEdictRequest interface.
 */
export function instanceOfTransferEdictRequest(value: object): value is TransferEdictRequest {
    if (!('sourceReference' in value) || value['sourceReference'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    return true;
}

export function TransferEdictRequestFromJSON(json: any): TransferEdictRequest {
    return TransferEdictRequestFromJSONTyped(json, false);
}

export function TransferEdictRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransferEdictRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sourceReference': json['sourceReference'],
        'clientId': json['clientId'],
    };
}

export function TransferEdictRequestToJSON(json: any): TransferEdictRequest {
    return TransferEdictRequestToJSONTyped(json, false);
}

export function TransferEdictRequestToJSONTyped(value?: TransferEdictRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sourceReference': value['sourceReference'],
        'clientId': value['clientId'],
    };
}

